import { render, staticRenderFns } from "./ChairDeviceBindingList.vue?vue&type=template&id=8d2eeb6e&scoped=true&"
import script from "./ChairDeviceBindingList.vue?vue&type=script&lang=js&"
export * from "./ChairDeviceBindingList.vue?vue&type=script&lang=js&"
import style0 from "./ChairDeviceBindingList.vue?vue&type=style&index=0&id=8d2eeb6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2eeb6e",
  null
  
)

export default component.exports